import React from "react";
import { Button, CardMedia, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  button: {
    width: "350px",
    height: "60px",
    backgroundColor: "#454C96",
    color: "#fff",
    display: "flex",
    margin: "0 auto",
    borderRadius: "12px",
    textTransform: "none",
    fontSize: "20px",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#454C96",
    },
  },
  media: {
    width: "24px",
    height: "24px",
    marginRight: theme.spacing(1),
  },
}));

interface EmployeeSignButtonProps {
  onClick?: () => void;
  signature?: string;
}

const isNullOrEmpty = (value?: string) => !value || value.trim() === "";

const EmployeeSignButton: React.FC<EmployeeSignButtonProps> = ({
  onClick,
  signature,
}) => {
  const classes = useStyles();
  return (
    <Button
      variant="contained"
      className={classes.button}
      startIcon={
        <CardMedia
          component="img"
          image={require("../icons/edit.png")}
          alt=""
          className={classes.media}
          style={!isNullOrEmpty(signature) ? { display: "none" } : {}}
        />
      }
      onClick={onClick}
    >
      員工簽署
    </Button>
  );
};

export default EmployeeSignButton;
